module.exports = __webpack_public_path__ + "static/Pear Therapeutics-db1acbbf37b8b139dd364a0202f3bb0b.jpg";